export default __webpack_public_path__ + "static/media/grafema_armazem-da-alfandega_02.936abf09.jpg";